export const opal = {
    baseTheme: 'opal',
    config: {
        colors: {
            palettes: {
                neutral: {
                    100: '#FFFFFF',
                    200: '#F6F6F6',
                    300: '#EBEBEC',
                    400: '#D6D6D6',
                    500: '#AAAAAA',
                    // Lightest grey that still clears the 3:1 non-text floor on white
                    550: '#949494',
                    600: '#707070',
                    700: '#4D4D4D',
                    800: '#1A1A1A',
                    900: '#0D0D0D',
                },
                red: {
                    100: '#FCF0F0',
                    200: '#FF4750',
                    300: '#EB141F',
                    400: '#910426',
                },
                orange: {
                    100: '#FFF1E0',
                    200: '#FFA166',
                    300: '#B75E00',
                    400: '#633703',
                },
                green: {
                    100: '#F1F8F3',
                    200: '#39C769',
                    300: '#007D2A',
                    400: '#005805',
                },
                blue: {
                    100: '#ECF4FE',
                    200: '#81B3F9',
                    300: '#1E458B',
                    400: '#122A54',
                },
                gray: {
                    100: '#808080',
                    200: '#373737',
                    300: '#1A1A1A',
                    400: '#000000',
                },
            },
            maps: {
                light: {
                    success: {
                        100: 'green.100',
                        200: 'green.200',
                        300: 'green.300',
                        400: 'green.400',
                    },
                    warning: {
                        100: 'orange.100',
                        200: 'orange.200',
                        300: 'orange.300',
                        400: 'orange.400',
                    },
                    danger: {
                        100: 'red.100',
                        200: 'red.200',
                        300: 'red.300',
                        400: 'red.400',
                    },
                    info: {
                        100: 'blue.100',
                        200: 'blue.200',
                        300: 'blue.300',
                        400: 'blue.400',
                    },
                    text: {
                        primary: 'neutral.900',
                        secondary: 'neutral.700',
                        placeholder: 'neutral.600',
                        inverse: 'neutral.100',
                        inverseSecondary: 'neutral.400',
                        success: 'green.300',
                        successOnSurface: 'green.400',
                        warning: 'orange.300',
                        warningOnSurface: 'orange.400',
                        danger: 'red.300',
                        dangerOnSurface: 'red.400',
                        info: 'blue.300',
                        infoOnSurface: 'blue.400',
                    },
                    background: {
                        primary: 'neutral.100',
                        secondary: 'neutral.300',
                        tertiary: 'neutral.200',
                        inverse: 'neutral.900',
                        opacity: 'neutral.900',
                        divider: 'neutral.400',
                        overlay: 'gray.400',
                        success: 'green.100',
                        warning: 'orange.100',
                        danger: 'red.100',
                        info: 'blue.100',
                    },
                    border: {
                        input: 'neutral.550',
                        inputFocused: 'neutral.900',
                        danger: 'red.300',
                        success: 'green.300',
                        warning: 'orange.300',
                        info: 'blue.300',
                    },
                    boxShadow: {
                        control: '0px 1px 3px 0px #00000026, 0px 0px 0px 1px #0000001A',
                    },
                },
                dark: {
                    success: {
                        100: 'green.400',
                        200: 'green.300',
                        300: 'green.200',
                        400: 'green.100',
                    },
                    warning: {
                        100: 'orange.400',
                        200: 'orange.300',
                        300: 'orange.200',
                        400: 'orange.100',
                    },
                    danger: {
                        100: 'red.400',
                        200: 'red.300',
                        300: 'red.200',
                        400: 'red.100',
                    },
                    info: {
                        100: 'blue.400',
                        200: 'blue.300',
                        300: 'blue.200',
                        400: 'blue.100',
                    },
                    text: {
                        primary: 'neutral.100',
                        secondary: 'neutral.400',
                        placeholder: 'neutral.500',
                        inverse: 'neutral.900',
                        inverseSecondary: 'neutral.700',
                        success: 'green.200',
                        successOnSurface: 'green.100',
                        warning: 'orange.200',
                        warningOnSurface: 'orange.100',
                        danger: 'red.200',
                        dangerOnSurface: 'red.100',
                        info: 'blue.200',
                        infoOnSurface: 'blue.100',
                    },
                    background: {
                        primary: 'neutral.900',
                        secondary: 'neutral.700',
                        tertiary: 'neutral.800',
                        inverse: 'neutral.100',
                        opacity: 'neutral.900',
                        divider: 'neutral.700',
                        overlay: 'gray.200',
                        success: 'green.400',
                        warning: 'orange.400',
                        danger: 'red.400',
                        info: 'blue.400',
                    },
                    border: {
                        input: 'neutral.600',
                        inputFocused: 'neutral.400',
                        danger: 'red.200',
                        success: 'green.200',
                        warning: 'orange.200',
                        info: 'blue.200',
                    },
                    boxShadow: {
                        control: '0px 0px 0px 1px #FFFFFF26, 0px 0px 0px 1px #FFFFFF1A',
                    },
                },
            },
            brand: {
                primary: '#0BB907',
                accessibleOverPrimary: '#0D0D0D',
                accessibleOverBackground: '#0BB907',
            },
        },
        font: {
            pairing: 'modern',
        },
        borderRadius: {
            small: 1,
            medium: 1.5,
            large: 2,
            control: 0.625,
        },
    },
};
//# sourceMappingURL=opal.js.map